export const MENU = {
  dashboard: 'Dashboard',
  assets: 'Assets',
  issues: 'Issues',
  users: 'Users',
  components: 'Components',
  inspections: 'Inspections',
  settings: 'Settings',
  notifications: 'Notifications',
  profile: 'Profile',
  customerAccounts: 'Customer Accounts',
  checklists: 'Checklists',
};

export const ACTIONS = {
  yes: 'Yes',
  no: 'No',
  logout: 'Logout',
  create: 'Create',
  generate: 'Generate',
  confirmation: 'Confirmation',
  update: 'Update',
  edit: 'Edit',
  delete: 'Delete',
  submit: 'Submit',
  cancel: 'Cancel',
  close: 'Close',
  clickToUpload: 'Click to Upload',
  assignToMaintenance: 'Assign to Maintenance',
  search: 'Search',
  clear: 'Clear',
  reset: 'Reset',
  readyForInspectorValidation: 'Ready for Inspector Validation',
  noFault: 'No Fault',
  add: 'Add',
  view: 'View',
  selectAll: 'Select All',
  selectCurrentPage: 'Current Page Only',
  back: 'Back',
  viewAll: 'View All',
  disable: 'Disable',
  enable: 'Enable',
  print: 'Print',
  markAsRead: 'Mark as Read',
  markAsUnread: 'Mark as Unread',
  loadMore: 'Load More...',
  recenterMap: 'Recenter Map',
  bulkDelete: 'Delete Selected',
  deleteAll: 'Delete All',
  save: 'Save',
  replaceImage: 'Replace Image',
  selectPresetImages: 'Select from preset images',
  upload: 'Upload',
  applyChanges: 'Apply Changes',
  apply: 'Apply',
  resetToDefault: 'Reset to Default',
};

export const LABELS = {
  asset: 'Asset',
  assets: 'Assets',
  assetId: 'Asset ID',
  make: 'Make',
  model: 'Model',
  image: 'Image',
  licensePlate: 'License Plate',
  odometer: 'Odometer',
  status: 'Status',
  success: 'Success',
  error: 'Error',
  listOfIssues: 'List of Issues',
  issue: 'Issue',
  issueId: 'Issue ID',
  reported: 'Reported',
  reportedBy: 'Reported by',
  description: 'Description',
  severity: 'Severity',
  setSeverity: 'Set Severity',
  photos: 'Photos',
  audioRecording: 'Audio Recording',
  advancedSearch: 'Advanced Search',
  component: 'Component',
  dateReported: 'Date Reported',
  from: 'From',
  to: 'To',
  type: 'Type',
  types: 'Types',
  inspection: 'Inspection',
  name: 'Name',
  area: 'Area',
  new: 'New',
  symptom: 'Symptom',
  symptoms: 'Symptoms',
  openIssues: 'Open Issues',
  reasonForNoFault: 'Reason for No Fault',
  qrCode: 'QR Code',
  location: 'Location',
  reasonForRework: 'Reason for Rework',
  dateValidated: 'Date Validated',
  validatedBy: 'Validated by',
  dateReworked: 'Date of Rework',
  reworkedBy: 'Reworked by',
  by: 'By',
  setBy: 'Set by',
  history: 'History',
  timeline: 'Timeline',
  thread: 'Thread',
  you: 'You',
  send: 'Send',
  edited: 'edited',
  remove: 'Remove',
  attachImage: 'Attach an image',
  recordVoice: 'Record a voice message',
  recording: 'Recording',
  stopRecording: 'Done',
  writeAMessage: 'Write a message…',
  loadEarlierMessages: 'Load earlier messages',
  brand: 'Brand',
  assetType: 'Asset Type',
  inspectionType: 'Inspection Type',
  fixed: 'Fixed',
  inRepair: 'In Repair',
  validating: 'Validating',
  user: 'User',
  users: 'Users',
  email: 'Email',
  firstName: 'First Name',
  lastName: 'Last Name',
  phoneNumber: 'Phone Number',
  customerAccount: 'Customer Account',
  customerName: 'Customer Name',
  customerShorthandName: 'Customer Shorthand Name',
  contactName: 'Contact Name',
  contactNumber: 'Contact Number',
  contactEmail: 'Contact Email',
  licenseStartDate: 'License Start Date',
  licenseEndDate: 'License End Date',
  licenseLength: 'License Length',
  inMonths: 'in months',
  assetLimit: 'Asset Limit',
  actions: 'Actions',
  customerAdminAccount: 'Customer Admin Account',
  customerAdminAccounts: 'Customer Admin Accounts',
  username: 'Username',
  dateCreated: 'Date Created',
  created: 'Created',
  deviceId: 'Device ID',
  obdDevice: 'Telematics Device',
  vin: 'Vehicle ID Number',
  assetDetails: 'Asset Details',
  groups: 'Groups',
  resolvedIssues: 'Resolved Issues',
  viewingIssuesOf: 'Viewing issues of',
  active: 'Active',
  inactive: 'Inactive',
  started: 'Started',
  completed: 'Completed',
  checklist: 'Checklist',
  checklistId: 'Checklist ID',
  checklistHistory: 'Checklist History',
  workingComponents: 'Working Components',
  issuesReported: 'Issues Reported',
  importUsers: 'Import Users',
  importAssets: 'Import Assets',
  file: 'File',
  importIssues: 'Import Issues',
  message: 'Message',
  messages: 'Messages',
  fleetHealth: 'Fleet Health',
  responseTime: 'Response Time',
  notification: 'Notification',
  fullName: 'Full Name',
  threshold: 'Threshold',
  assetTypeMaintenance: 'Asset Type Maintenance',
  createdUsers: 'Create Users',
  deletedUsers: 'Delete Users',
  updatedUsers: 'Update Users',
  invalidUsers: 'Invalid Users',
  createdAssets: 'Create Assets',
  deletedAssets: 'Delete Assets',
  updatedAssets: 'Update Assets',
  invalidAssets: 'Invalid Assets',
  importPreview: 'Import Preview',
  startDate: 'Start Date',
  endDate: 'End Date',
  remarks: 'Remarks',
  license: 'License',
  licenseInformation: 'License Information',
  unavailable: 'Unavailable',
  userProfile: 'User Profile',
  kilometer: 'km',
  volts: 'V',
  telematicsInformation: 'Telematics Information',
  batteryVoltage: 'Battery Voltage',
  ignitionState: 'Ignition State',
  online: 'Online',
  offline: 'Offline',
  on: 'On',
  off: 'Off',
  warning: 'Warning',
  disabled: 'Disabled',
  temporaryAdmin: 'Temporary Admin',
  credentials: 'Credentials',
  password: 'Password',
  userExpiry: 'User Expiry Date',
  resendVerification: 'Resend Activation',
  hoursAndMinutes: 'HH:MM',
  generateReport: 'Generate Report',
  appearance: 'Brand & Appearance',
  appearanceInfo:
    'Match the workspace to your corporate identity. Change preview instantly on the right, apply when you are happy.',
  resetTheme: 'Reset Theme',
  resetThemeConfirm: 'Are you sure you want to reset to default?',
  resetColorPalette: 'Color palette',
  resetBrandLogo: 'Brand logo',
  changeTheme: 'Change Theme.',
  changeThemeConfirm: 'Are you sure you want to apply this changes?',
  colorPalette: 'Color Palette',
  pickPalette: 'Pick a pre-defined color palette.',
  presets: 'Presets',
  customPresets: 'Custom Preset',
  customizePresetsInfo: 'Create and customize your own color theme',
  customPresetGuide: 'Color guide',
  customPresetGuidePrimary: '900 — Most Solid / Primary',
  customPresetGuidePrimaryStrong: 'Pick a strong, deep color.',
  customPresetGuidePrimaryUse:
    'It fills your layout — the sidebar, the header bar, and the logo background — plus anything marked as primary, like link buttons and list icons.',
  customPresetGuideSecondary: '100 — Light / Secondary',
  customPresetGuideSecondaryLight:
    'Pick a very light version of your primary — the same color, just much paler.',
  customPresetGuideSecondaryUse:
    'It fills subtle backgrounds, hovers, and highlights, so it needs to stay readable behind dark text.',
  customPresetGuideAvoid: 'Avoid',
  customPresetGuideAvoidSimilar:
    'Two strong shades. If the primary and secondary are close in depth, the elements that rely on the contrast between them blend together.',
  brandLogo: 'Brand Logo',
  brandLogoInfo: "Upload your logo to replace Shlonak's across the workspace.",
  fullLogo: 'Full logo',
  fullLogoTarget: 'Sidebar',
  fullLogoHint: 'SVG or PNG · max 1 MB',
  fullLogoRatioHint: 'Best size: 1200 x 256 px (wide, banner-shaped)',
  iconMark: 'Icon mark',
  iconMarkTarget: 'Optional · mobile',
  iconMarkHint: 'SVG or PNG · max 1 MB',
  iconMarkRatioHint: 'Best size: 128 x 128 px (square)',
  clickToUpload: 'Click to Upload',
  dragFileHere: 'or drag a file here',
  uploading: 'Uploading…',
  desktopLogo: 'Desktop Logo',
  mobileLogo: 'Mobile Logo',
  brandLogoGuide: 'Logo requirements',
  brandLogoGuideDesktop: 'Desktop logo — shown in the sidebar',
  brandLogoGuideDesktopSize: 'Best size: 1200 x 256 px, a wide banner shape',
  brandLogoGuideDesktopMin: 'Minimum width: 672 px',
  brandLogoGuideMobile: 'Mobile logo — shown when the sidebar is collapsed',
  brandLogoGuideMobileSize: 'Best size: 128 x 128 px, a square icon',
  brandLogoGuideMobileMin: 'Minimum width: 120 px',
  brandLogoGuideShared: 'Both logos',
  brandLogoGuideFormat: 'SVG or PNG only, up to 1 MB each',
  brandLogoGuideTransparent:
    'Use a transparent background so the logo matches your theme',
  brandLogoGuideSvg: 'SVG is best — it stays sharp on every screen',
};

export const ALL_LABELS = {
  ...LABELS,
  ...ACTIONS,
  ...MENU,
};
